import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import CategoryHeading from '../../../CategoryHeading';
import breakpoints from '../../../Theme/breakpoints';

const MoreNewsWrapper = styled.section`
  @media (min-width: ${breakpoints.lg}px) {
    padding: 24px 0 0;
    border-top: 1px solid ${({ theme }) => theme.colors?.greyDark};
  }
`;

const MoreNewsRow = styled.div`
  @media (min-width: ${breakpoints.sm}px) {
    display: grid;
    grid-template-columns: repeat(2, 50%);
  }

  @media (min-width: ${breakpoints.lg}px) {
    grid-template-columns: calc(
      25% + 12.75px
    ) calc(
      25% + 12.75px
    ) calc(
      25% + 12.75px
    ) calc(
      25% - 36.75px
    );
    padding: 24px 0;
    border-top: 1px solid ${({ theme }) => theme.colors?.greyLight};
    :first-of-type {
      padding: 0 0 24px;
      border-top: none;
    }
  }
`;

const MoreNewsItem = styled.div`
  @media (min-width: ${breakpoints.sm}px) {
    :nth-of-type(even) {
      padding: 0 0 0 16px;
    }
    :nth-of-type(odd) {
      padding: 0 16px 0 0;
    }
  }

  @media (min-width: ${breakpoints.lg}px) {
    :nth-of-type(1), :nth-of-type(2), :nth-of-type(3) {
      padding: 0 24px 0 0;
      margin-right: 24px;
      border-right: 1px solid ${({ theme }) => theme.colors?.greyLight};
    }

    :last-of-type {
      padding: 0;
      margin-right: 0;
      border-right: none;
    }
  }
`;

const StyledCategoryHeading = styled(CategoryHeading)`
  && {
    margin-bottom: 24px;

    @media (min-width: ${breakpoints.sm}px) {
      width: 100%;
    }
  }
`;

const MoreNews = ({
  categoryHeading,
  rows,
}) => (
  <MoreNewsWrapper>
    <StyledCategoryHeading>
      {categoryHeading}
    </StyledCategoryHeading>
    { rows.map(
      (block) => (
        <MoreNewsRow key={block.props.offset}>
          {block}
        </MoreNewsRow>
      ),
    ) }
  </MoreNewsWrapper>
);

MoreNews.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.node,
  ).isRequired,
  categoryHeading: PropTypes.string,
};

MoreNews.defaultProps = {
  categoryHeading: undefined,
};

export { MoreNews, MoreNewsItem, StyledCategoryHeading };
